import Vue from 'vue'
import Router from 'vue-router'
import auth from "@/services/authService"

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [{
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '/',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        {
          path: '',
          name: 'admin-results',
          component: () => import('./views/admin/lotto/Dashboard.vue'),
          meta: {
            rule: 'admin',
            pageTitle: 'Lotto Manage',
            title: 'Lotto Manage'
          }
        },
        {
          path: 'result/:lottoType',
          name: 'admin-lotto-results',
          component: () => import('./views/admin/lotto/Results.vue'),
          meta: {
            rule: 'admin',
            pageTitle: '',
            title: ''
          }
        },
        {
          path: 'result/:lottoType/add',
          name: 'admin-add-results',
          component: () => import('./views/admin/lotto/AddResults.vue'),
          meta: {
            rule: 'admin',
            pageTitle: '',
            title: ''
          }
        },
        {
          path: 'result/:lottoType/:resultId',
          name: 'admin-edit-results',
          component: () => import('./views/admin/lotto/EditResults.vue'),
          meta: {
            rule: 'admin',
            pageTitle: 'จัดการผลหวย',
            title: 'แก้ไขผลหวย'
          }
        },
        {
          path: 'profile',
          name: 'user-profile',
          component: () => import('./views/account/Profile.vue'),
          meta: {
            rule: 'loggedin',
            breadcrumb: [
              { title: 'หน้าแรก', url: '/' },
              { title: 'ตั้งค่าข้อมูลส่วนตัว', active: true },
            ],
            pageTitle: 'Profile',
            title: 'Profile'
          },
        }
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [{
          path: '/login',
          name: 'auth-login',
          component: () => import('@/views/auth/Login.vue'),
          meta: {
            rule: 'public',
            title: 'เข้าสู่ระบบ'
          }
        },
        {
          path: '/error-404',
          name: 'auth-error-404',
          component: () => import('@/views/auth/Error404.vue'),
          meta: {
            rule: 'public',
            title: 'ไม่มีข้อมูล'
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/login'
    }
  ],
})

router.beforeEach((to, from, next) => {

  //const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  //if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  //console.log('to', to)
  if(to.name === 'admin-lotto-results' || to.name === 'admin-add-results') {
    switch(to.params.lottoType) {
      case 'england':
        to.meta.pageTitle = 'ENGLAND VIP'
        to.meta.title = 'ENGLAND'
        break;
      case 'germany':
        to.meta.pageTitle = 'GERMANY VIP'
        to.meta.title = 'GERMANY'
        break;
      case 'russia':
        to.meta.pageTitle = 'RUSSIA VIP'
        to.meta.title = 'RUSSIA'
        break;
    }
  }

  // ถ้ามีการ Login เรียบร้อยแล้ว มาเข้าที่หน้า login ให้ redirect ไปที่หน้า Admin
  if (to.name === "auth-login" && auth.isLoggedIn()) {
    router.push({ name: 'admin-results' })
    return
  } else
  if (to.meta.rule === 'admin' && !auth.isLoggedIn()) {
    router.push({ name: 'auth-login' })
    return
  } else
  if (to.meta.rule === 'public' || auth.isLoggedIn()) {
    return next()
  } else {
    router.push({ name: 'show-result' })
    return
  }

});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})

export default router
